export default __webpack_public_path__ + "static/media/add.f19d653e.svg";